import { createContext, useEffect, useState } from "react";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  // Initial currency from localStorage (GeoIP sets this on first visit)
  const [currency, setCurrency] = useState(
    localStorage.getItem("currency") || "USD"
  );

  // Keep localStorage in sync if currency changes
  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  // User-triggered currency change (manual override)
  const changeCurrency = (newCurrency) => {
    setCurrency(newCurrency);
  };

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        changeCurrency
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
